

















































































import {Component, Vue, Watch} from "vue-property-decorator";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {
  ClearingDebtType,
  ExpensePaymentType,
  ReceiptExpensesPickingListTargetType,
  ReceiptExpensesType
} from "@/enums/type";
import {cloneDeep, difference, union} from "lodash";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {ExpenseCustomerStore} from "@/modules/receiptsexpenses/expensecustomer/store";
import {ExpenseCustomerParams} from "@/modules/receiptsexpenses/expensecustomer/params";
import {DebtCustomer} from "@/interfaces/entity";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import ExpenseDebtCustomerTable
  from "@/modules/receiptsexpenses/expensecustomer/Form/components/ExpenseDebtCustomerTable/index.vue";
import ConfirmReceiptExpense from "@/modules/receiptsexpenses/shared/components/ConfirmReceiptExpense/index.vue";
import {CustomerStore} from "@/modules/customers/store";
import PrintReceiptExpense from "@/modules/receiptsexpenses/shared/components/PrintReceiptExpense/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import ExpenseCustomerPickingListPrint from "@/modules/receiptsexpenses/expensecustomer/shared/Print/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";

const form = {
    paymentType: undefined,
    debtIds: [],
    customerRowGuid: undefined,
    type: ReceiptExpensesType.PickingListPay,
    note: undefined,
    clearingType: ClearingDebtType.Yes,
    bankAccount: undefined,
    fromDate: undefined,
    toDate: undefined
};

@Component({
    name: "ExpenseCustomerForm",
    components: {
        AInputBarCode,
        ExpenseCustomerPickingListPrint,
        PrintReceiptExpense,
        ConfirmReceiptExpense,
        ExpenseDebtCustomerTable, CustomerSelector, LadingPaymentTypeLabel, EnumSelector, EmployeeSelector, MillisecondDatePicker
    }
})
export default class extends Vue {
    ExpensePaymentType = ExpensePaymentType;
    ClearingDebtType = ClearingDebtType;
    form = cloneDeep(form);
    ladingCode = "";
    selectedIds: number[] = [];
    isSaving = false;
    visibleConfirm = false;

    expensePickingListId = null as any;
    printObj = {
        id: "expense-customer-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };

    created() {
        ExpenseCustomerStore.clearExpenseCustomerStore();
    }

    @Watch("form.customerRowGuid")
    onChangeCustomerRowGuid(val: any) {
        this.form.debtIds = [];
        if (!val) return;
        ExpenseCustomerStore.listCreditCustomer({...new ExpenseCustomerParams(), customerRowGuid: val, limit: 20000, isCollectCurrent: 1, fromDate: this.form.fromDate, toDate: this.form.toDate});
    }

    @Watch("form.fromDate")
    onChangeFromDate(val: any) {
      this.form.debtIds = [];
      if (!this.form.customerRowGuid) return;
      ExpenseCustomerStore.listCreditCustomer({...new ExpenseCustomerParams(), customerRowGuid: this.form.customerRowGuid, limit: 20000, isCollectCurrent: 1, fromDate: val, toDate: this.form.toDate});
    }

    @Watch("form.toDate")
    onChangeToDate(val: any) {
      this.form.debtIds = [];
      if (!this.form.customerRowGuid) return;
      ExpenseCustomerStore.listCreditCustomer({...new ExpenseCustomerParams(), customerRowGuid: this.form.customerRowGuid, limit: 20000, isCollectCurrent: 1, fromDate: this.form.fromDate, toDate: val});
    }

    onChangeLadingCode(evt: any) {
        const val = evt?.target?.value;
        const debtIds: number[] = this.expenseCustomers
            .filter((credit: DebtCustomer) => credit.billLading?.ladingCode === val)
            .map((credit: DebtCustomer) => credit.id);
        this.form.debtIds = union(this.form.debtIds, debtIds) as any;
        setTimeout(() => this.ladingCode = "", 500);
    }

    get expenseCustomers() {
        return ExpenseCustomerStore.ids.map((id: number) => ExpenseCustomerStore.data[id]);
    }

    get dataConfirm() {
        const debts = this.form.debtIds.map((id: number) => ExpenseCustomerStore.data[id]);
        const target = {
            type: ReceiptExpensesPickingListTargetType.Customer,
            name: this.form.customerRowGuid ? CustomerStore.data[this.form.customerRowGuid as any]?.fullName : ''
        }
        const totalMoney = ClearingDebtType.Yes === this.form.clearingType
            ? debts.reduce((accumulator, currentValue, currentIndex, array) => {
                const clearingMoney = currentValue?.clearingMoney;
                const codMoney = currentValue?.billLading?.codMoney
                return accumulator + (codMoney ? codMoney : 0) - (clearingMoney ? clearingMoney : 0);
            }, 0)
            : debts.reduce((accumulator, currentValue, currentIndex, array) => {
                return accumulator + currentValue?.billLading?.codMoney || 0
            }, 0);
        return {
            debts,
            target,
            isExpense: true,
            totalMoney,
            clearingType: this.form.clearingType
        }
    }

    totalMoney() {
      const debts = this.form.debtIds.map((id: number) => ExpenseCustomerStore.data[id]);
      return ClearingDebtType.Yes === this.form.clearingType
          ? debts.reduce((accumulator, currentValue, currentIndex, array) => {
            const clearingMoney = currentValue?.clearingMoney;
            const codMoney = currentValue?.billLading?.codMoney
            return accumulator + (codMoney ? codMoney : 0) - (clearingMoney ? clearingMoney : 0);
          }, 0)
          : debts.reduce((accumulator, currentValue, currentIndex, array) => {
            return accumulator + currentValue?.billLading?.codMoney || 0
          }, 0);
    }

    onSelectedIdsChange(selectedIds: any) {
        this.form.debtIds = selectedIds;
    }

    async onSave() {
        try {
            if (!this.isValidForm()) return;
            this.isSaving = true;
            this.visibleConfirm = false;
            const data = await ExpenseCustomerStore.expenseCustomer(this.form);
            this.expensePickingListId = data.id;
            this.$message.success("Trả tiền khách hàng thành công");
            (this.$refs.printReceiptExpense as any).$el.click();
            this.refresh();
        } catch (e) {
            console.log(e);
            this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
            this.visibleConfirm = false;
        }
        this.isSaving = false;
    }

    confirm() {
        if (!this.isValidForm()) return;
        this.visibleConfirm = true;
    }

    isValidForm() {
        if (!this.form.customerRowGuid) {
            this.$message.error("Vui lòng chọn khách hàng");
            return false;
        }
        if (!this.form.debtIds.length) {
            this.$message.error("Vui lòng quét mã vận đơn để thu");
            return false;
        }
        if (!this.form.paymentType) {
            this.$message.error("Vui lòng chọn hình thức thanh toán");
            return false;
        }
        return true;
    }

    refresh() {
        this.ladingCode = "";
        this.form = cloneDeep(form);
        ExpenseCustomerStore.clearExpenseCustomerStore();
    }

    acceptDebt() {
        const deletedDebtCustomerIds = difference(ExpenseCustomerStore.ids, this.form.debtIds);
        ExpenseCustomerStore.deleteDebtEmployeeByIds(deletedDebtCustomerIds);
    }
}
